import React from 'react'
import { useNavigate } from 'react-router-dom'
import Logo from '../components/Logo'

export default function OnboardingSuccessPage() {
  const navigate = useNavigate()

  return (
    <div className="min-h-screen bg-[#f5f5f4] dark:bg-[#111] flex items-center justify-center p-5">
      <div className="bg-white dark:bg-[#1e1e1e] border border-[#e5e5e3] dark:border-[#2e2e2e] rounded-xl p-9 w-full max-w-[440px] text-center">
        <div className="mb-7 flex justify-center"><Logo size="lg" /></div>
        <div className="w-[52px] h-[52px] bg-[#f0fdf4] rounded-full flex items-center justify-center mx-auto mb-4 text-[22px]">
          ✓
        </div>
        <h1 className="text-[20px] font-medium tracking-[-0.3px] dark:text-[#f0f0ef] mb-1.5">You're all set</h1>
        <p className="text-[14px] text-[#888] dark:text-[#666] mb-5 leading-relaxed">Your workspace is ready. Here's what was set up:</p>
        <div className="flex gap-2 justify-center mb-5">
          <div className="bg-[#f5f5f4] dark:bg-[#252525] rounded-full px-3.5 py-1.5 text-[12px] text-[#555] dark:text-[#aaa]">
            <strong className="text-[#1a1a1a] dark:text-[#f0f0ef] font-medium">7</strong> skills imported
          </div>
          <div className="bg-[#f5f5f4] dark:bg-[#252525] rounded-full px-3.5 py-1.5 text-[12px] text-[#555] dark:text-[#aaa]">
            <strong className="text-[#1a1a1a] dark:text-[#f0f0ef] font-medium">2</strong> sources connected
          </div>
          <div className="bg-[#f5f5f4] dark:bg-[#252525] rounded-full px-3.5 py-1.5 text-[12px] text-[#555] dark:text-[#aaa]">
            <strong className="text-[#1a1a1a] dark:text-[#f0f0ef] font-medium">1</strong> destination
          </div>
        </div>
        <button
          onClick={() => navigate('/')}
          className="w-full py-2.5 bg-[#1a1a1a] dark:bg-[#f0f0ef] text-white dark:text-[#1a1a1a] rounded-[7px] text-[14px] font-medium hover:bg-[#333] dark:hover:bg-[#ddd] cursor-pointer"
        >
          Open Skilflow →
        </button>
      </div>
    </div>
  )
}
